import React from 'react';
import { createRoot } from 'react-dom/client';
import 'normalize.css';
import './App.css';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Font Awesome global setup
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faAsterisk, faBars, faTimes, faArrowUp, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

library.add(faLinkedinIn, faGithub, faAsterisk, faBars, faTimes, faArrowUp, faUpRightFromSquare);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();